<script>
import {Graylog} from '../graylog'
import SearchOptions from './SearchOptions.vue'

export default {

  components: {
    SearchOptions
  },

  data() {
    return {
      showLegends: false,

      pieChartData: {
        iOS: {},
        Android: {}
      },

      lineCharts: [
        {
          data: [],
          title: '# Requests',
          height: '350px'
        }
        // {
        //   data: [],
        //   title: 'Avg Response Time',
        //   height: '350px',
        // },
      ],

      // default search params
      searchParams: {
        facility: 'production',
        range: 12*60*60,
        interval: 'day'
      }
    }
  },

  watch: {
    searchParams: {
      deep: true,
      handler() { this.fetch() }
    },
  },

  mounted() {
    this.fetch()
  },

  methods: {
    fetch() {
      this.fetchLineCharts()

      this.fetchPieChart('iOS', 'ios_app_id', '_exists_:ios_app_id', 'WL App')
      this.fetchPieChart('iOS', 'ios_app_version', '_exists_:ios_app_version', 'App Versions')
      this.fetchPieChart('iOS', 'selected_team', '_exists_:ios_app_version', 'Team')
      this.fetchPieChart('Android', 'android_app_id', '_exists_:android_app_id', 'WL App')
      this.fetchPieChart('Android', 'android_app_version', '_exists_:android_app_version', 'App Versions')
      this.fetchPieChart('Android', 'selected_team', '_exists_:android_app_version', 'Team')
    },

    fetchLineCharts() {
      Graylog.getFieldHistogramm('time', `facility:"${this.searchParams.facility}" AND _exists_:ios_app_version`, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        this.$set(this.lineCharts[0].data, 0, { name: 'iOS', data: Graylog.toTimeline(response.data.results, 'total_count') })
        //this.$set(this.lineCharts[1].data, 0, { name: 'iOS', data: Graylog.toTimeline(response.data.results, 'mean') })
      })

      Graylog.getFieldHistogramm('time', `facility:"${this.searchParams.facility}" AND _exists_:android_app_version`, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        this.$set(this.lineCharts[0].data, 1, { name: 'Android', data: Graylog.toTimeline(response.data.results, 'total_count') })
        //this.$set(this.lineCharts[1].data, 1, { name: 'Android', data: Graylog.toTimeline(response.data.results, 'mean') })
      })

      Graylog.getFieldHistogramm('time', `facility:"${this.searchParams.facility}" AND NOT(_exists_:ios_app_version) AND NOT(_exists_:android_app_version) AND _exists_:controller AND role:driver`, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        this.$set(this.lineCharts[0].data, 2, { name: 'Driver Web', data: Graylog.toTimeline(response.data.results, 'total_count') })
        //this.$set(this.lineCharts[1].data, 0, { name: 'iOS', data: Graylog.toTimeline(response.data.results, 'mean') })
      })

      Graylog.getFieldHistogramm('time', `facility:"${this.searchParams.facility}" AND NOT(_exists_:ios_app_version) AND NOT(_exists_:android_app_version) AND _exists_:controller AND role:team_admin`, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        this.$set(this.lineCharts[0].data, 3, { name: 'Team-Admin Web', data: Graylog.toTimeline(response.data.results, 'total_count') })
        //this.$set(this.lineCharts[1].data, 0, { name: 'iOS', data: Graylog.toTimeline(response.data.results, 'mean') })
      })

      Graylog.getFieldHistogramm('time', `facility:"${this.searchParams.facility}" AND NOT(_exists_:ios_app_version) AND NOT(_exists_:android_app_version) AND _exists_:controller AND role:provider_admin`, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        this.$set(this.lineCharts[0].data, 4, { name: 'Provider-Admin Web', data: Graylog.toTimeline(response.data.results, 'total_count') })
        //this.$set(this.lineCharts[1].data, 0, { name: 'iOS', data: Graylog.toTimeline(response.data.results, 'mean') })
      })

      Graylog.getFieldHistogramm('time', `facility:"${this.searchParams.facility}" AND NOT(_exists_:ios_app_version) AND NOT(_exists_:android_app_version) AND _exists_:controller AND role:platform_admin`, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        this.$set(this.lineCharts[0].data, 5, { name: 'Platform-Admin Web', data: Graylog.toTimeline(response.data.results, 'total_count') })
      })

      Graylog.getFieldHistogramm('time', `facility:"${this.searchParams.facility}" AND NOT(_exists_:ios_app_version) AND NOT(_exists_:android_app_version) AND _exists_:controller AND role:customer_service`, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        this.$set(this.lineCharts[0].data, 6, { name: 'customer_service Web', data: Graylog.toTimeline(response.data.results, 'total_count') })
      })

      Graylog.getFieldHistogramm('time', `facility:"${this.searchParams.facility}" AND NOT(_exists_:ios_app_version) AND NOT(_exists_:android_app_version) AND _exists_:controller AND role:support`, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        this.$set(this.lineCharts[0].data, 7, { name: 'support Web', data: Graylog.toTimeline(response.data.results, 'total_count') })
      })

      Graylog.getFieldHistogramm('time', `facility:"${this.searchParams.facility}" AND NOT(_exists_:ios_app_version) AND NOT(_exists_:android_app_version) AND _exists_:controller AND role:operator`, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        this.$set(this.lineCharts[0].data, 8, { name: 'operator Web', data: Graylog.toTimeline(response.data.results, 'total_count') })
      })

    },

    fetchPieChart(group, field, query, title) {
      Graylog.getTerms(`facility:"${this.searchParams.facility}" AND ${query}`, {
        range: this.searchParams.range,
        field: field
      }).then(response => {
        this.$set(this.pieChartData[group], field, {
          field: field,
          title: title,
          data: response.data.terms
        });
        //this.applyPieClickEvents(field)
      });
    }

  }

}
</script>

<template>
  <div>
    <SearchOptions :searchParams="searchParams"/>

    <label v-if="false">
      <input type="checkbox" v-model="showLegends">
      Show Legend
    </label>

    <div class="grid-x grid-margin-x">
      <div class="cell medium-12" v-for="chartData in lineCharts" v-bind:key="chartData.title">
        <line-chart v-if="chartData.data" :data="chartData.data" :ytitle="chartData.title" :height="chartData.height" :curve="false"></line-chart>
        <br/><br/>
      </div>
    </div>

    <div class="grid-x grid-margin-x" v-for="group in ['iOS', 'Android']" :key="group">
      <br>
      <div class="cell small-12">
        <h3>Requests from {{ group }} by...</h3>
      </div>
      <div v-for="pieChart in pieChartData[group]" :key="pieChart.field" class="cell medium-4">
        <h5>{{pieChart.title}}</h5>
        <pie-chart :ref="'pie-'+pieChart.field" height="250px" :data="pieChart.data" :legend="showLegends" :donut="true"></pie-chart>
        <br><br><br>
      </div>
    </div>

  </div>
</template>

<style>

</style>
